import { Pressable, FlatList, View, Image } from "react-native";
import { FindifyTopBarOverlay } from "../genericPages/components/FindifyTopBarOverlay";
import React, { useContext, useEffect, useState } from "react";
import { PlaceColors } from "../genericPages/helpers/PlaceColors";
import { BasePage } from "../genericPages/helpers/BasePage";
import { useTranslation } from "react-i18next";
import { FindifySimpleHeader, SimpleHeaderAction } from "../genericPages/components/FindifySimpleHeader";
import { FindifyDataContext, FindifyDataContextType } from "@/contexts/FindifyDataContext";
import { PlaceText } from "../genericPages/components/PlaceText";
import { BaseFindifyList } from "../genericPages/components/FindifyList";
import { getTranslatedString } from "../genericPages/helpers/FindifyTranslatedString";
import { PlaceListInitialUseEffect, PlaceListOnSelectedCategoryChangeEffect, loadContentsPageFromApi } from "@/layouts/genericPages/helpers/PlaceListHelper";
import { DefaultShadow } from "../genericPages/helpers/DefaultShadows";
import { FindifyBasicModal } from "./components/FindifyBasicModal";
import QRCode from "react-qr-code";
import { makeDateString, makeEventDate } from "./helpers/DetailsHelpers";
import { getApiFromModule } from "./helpers/GetContentsByModule";
import { IS_QA_MODE, environment } from "@/config/environment";

export const UserTicketsPage = ({ navigation, ...props }: any) => {
    const [contents, setContents] = useState([]);
    const { t } = useTranslation();
    const [module, setModule] = useState('');
    const [selectedCategories, setSelectedCategories] = useState<number[]>([]);
    const findifyDataContext = useContext(FindifyDataContext);
    const [loaded, setLoaded] = useState(false);
    const [availableModuleCategories, setAvailableModuleCategories] = useState<any[]>([]);
    const [actionsList, setActionsList] = useState<SimpleHeaderAction[]>([]);
    const [selectedTicket, setSelectedTicket] = useState<any>(undefined);

    useEffect(() => {
        PlaceListInitialUseEffect({
            props,
            setContents,
            setLoaded,
            setModule,
            setSelectedCategories,
            findifyDataContext,
            setAvailableModuleCategories,
            contents,
            ignoreContentsWithoutCategory: false,
            pageModule: 'user_tickets',
        });
    }, [])


    useEffect(() => {
        PlaceListOnSelectedCategoryChangeEffect({
            loaded,
            selectedCategories,
            setContents,
            module,
            findifyDataContext,
            setActionsList,
            availableModuleCategories,
            t,
        });
    }, [selectedCategories])


    const header = <FindifySimpleHeader navigation={navigation}
        // module if no category filter or multiple category filter, single cat filter shows cat title
        title={
            t('modules.user_tickets')
        }
        isEventLayout
        actions={actionsList}
    // image={findifyDataContext?.workspace.app_settings?.app_banner_url} 
    />;

    return <BasePage navigation={navigation}>
        <FindifyTopBarOverlay />
        <BaseFindifyList
            items={contents.map((ticket: any) => {
                return {
                    ...ticket,
                    onPress: () => { // Set selected ticket to open modal
                        setSelectedTicket(ticket);
                    }
                };
            })}
            header={<>
                {header}
                <FlatList
                    key={'listcategories'}
                    data={availableModuleCategories}
                    horizontal
                    renderItem={({ item, index }) => {
                        const catSelected = selectedCategories.includes(item.category_id);
                        return <Pressable
                            onPress={() => {
                                if (catSelected) {
                                    setSelectedCategories(selectedCategories.filter(cat => cat !== item.category_id));
                                } else {
                                    setSelectedCategories([...selectedCategories, item.category_id]);
                                }
                            }}
                            style={{
                                ...DefaultShadow,
                                borderRadius: 100,
                                backgroundColor: catSelected ?
                                    PlaceColors(findifyDataContext).text.get()
                                    : PlaceColors(findifyDataContext).background.get(),
                                padding: 10,
                                marginVertical: 4,
                                marginLeft: 6,
                            }}
                        >
                            <PlaceText
                                style={{
                                    color: catSelected ?
                                        PlaceColors(findifyDataContext).background.get() :
                                        PlaceColors(findifyDataContext).text.get(),
                                }}
                            >
                                {getTranslatedString(item.name, findifyDataContext)}
                            </PlaceText>
                        </Pressable>;
                    }} />
            </>}
            onEndReached={() => {
                if (loaded) {
                    loadContentsPageFromApi(selectedCategories, contents, module, findifyDataContext, setContents);
                }
            }}
            renderLine={(item, index) => {
                return <Pressable onPress={item.onPress}>
                    <UserTicketData findifyDataContext={findifyDataContext} t={t} ticket={item} />
                </Pressable>;
            }}
            enableGrid={false}
        />
        <UserTicektModal
            selectedTicket={selectedTicket}
            setSelectedTicket={setSelectedTicket}
            findifyDataContext={findifyDataContext}
            t={t}
        />
    </BasePage >;
};



const UserTicektModal = ({ selectedTicket, setSelectedTicket, findifyDataContext, t, }: {
    selectedTicket: any,
    setSelectedTicket: Function,
    findifyDataContext: FindifyDataContextType,
    t: any,
}) => {
    const userTicketsApi = getApiFromModule('user_tickets', findifyDataContext);
    const [qrCode, setQRCode] = useState<any>(null)

    useEffect(() => {
        setQRCode(null);
        if (selectedTicket) {
            // Load Ticket QR
            userTicketsApi.generateQR(selectedTicket?.ticket_id).then((data: any) => {
                setQRCode(data);
            })
        }
    }, [selectedTicket])

    return <FindifyBasicModal
        isOpen={selectedTicket ? true : false}
        transparent={true}
        closeModal={() => setSelectedTicket(undefined)}
    >
        <UserTicketData findifyDataContext={findifyDataContext} t={t} ticket={selectedTicket} qrCode={qrCode} isModal={true} />
    </FindifyBasicModal>
}

const UserTicketData = ({ findifyDataContext, t, ticket, qrCode, isModal }: any) => {

    return <View style={[{
        backgroundColor: PlaceColors(findifyDataContext).alternateListBG.get(),
        margin: 5,
        borderRadius: 8,
        flexDirection: 'column',
        padding: isModal ? 10 : 0,
        gap: isModal ? 20 : 0,
        alignItems: 'center',
    }]}>
        <View
            style={{
                flexDirection: isModal ? 'column' : 'row',
                alignItems: isModal ? 'center' : null,
                borderRadius: 8,
                width: '100%',
                gap: 4,
            }}
        >
            {ticket?.ticket_collection_ticket?.ticket_collection?.featured_image_media &&
                <Image style={{
                    width: isModal ? 'auto' : 110,
                    minWidth: isModal ? '80%' : null,
                    borderRadius: 8,
                    height: 110,
                    objectFit: isModal ? 'contain' : 'cover'
                }} source={{ uri: (IS_QA_MODE ? environment.FILE_URL_QA : environment.FILE_URL) + ticket?.ticket_collection_ticket.ticket_collection.featured_image_media.file_path }} />
            }
            <View
                style={{
                    flexDirection: 'column',
                    paddingVertical: 2,
                    paddingHorizontal: 8,
                }}
            >
                <PlaceText style={{
                    color: PlaceColors(findifyDataContext).text.get(),
                    fontSize: 18,
                    fontWeight: 'bold',
                }}>{ticket?.ticket_collection_ticket.ticket_collection.name}</PlaceText>
                <PlaceText style={{
                    color: PlaceColors(findifyDataContext).text.get(),
                    fontSize: 14,
                }}>
                    {ticket?.ticket_collection_ticket.ticket_collection.description}
                </PlaceText>
                <View
                    style={{
                        flexDirection: 'column',
                        gap: 4,
                        marginTop: 'auto'
                    }}
                >

                    <PlaceText style={{
                        color: PlaceColors(findifyDataContext).text.get(),
                        fontSize: 14,
                    }}>
                        {makeEventDate(findifyDataContext.language, ticket?.ticket_collection_ticket?.ticket_collection?.event?.start_date, ticket?.ticket_collection_ticket?.ticket_collection?.event?.end_date)}{"\n"}
                        {ticket?.ticket_collection_ticket.ticket_section.section_name} - {ticket?.ticket_collection_ticket.ticket_type.name}{ticket?.seated_row && ` - ${ticket?.seated_row}`} {ticket?.seated_column && `${ticket?.seated_column}`}{"\n"}
                        {ticket.was_validated ? `${t('base.tickets.used_at')} ${makeDateString(new Date(ticket?.validated_date))}` : t('base.tickets.unused')}
                    </PlaceText>
                </View>
            </View>
        </View>
        {qrCode &&
            <QRCode
                style={{
                    width: '60%',
                    height: '60%',
                }}
                value={qrCode} />
        }
    </View>;
}